import { userConstants } from '../_constants';
import { history } from '../_helpers';
import { goToLogin } from "../_helpers/navHelpers";
import { userService } from '../_services';
import { alertActions } from './';

export const userActions = {
    login,
    logout,
    register,
    clear,
    throwError
};

function clear() {
    return dispatch => {
        dispatch(alertActions.clear());
    };
}

function login(username, password, isRegisteredUser, vendor) {
    return dispatch => {
        dispatch(request({ username, password, isRegisteredUser, vendor }));
        dispatch(alertActions.clear())
        userService.login(username, password, isRegisteredUser, vendor)
            .then(
                user => {
                    dispatch(success(user));
                },
                error => {
                    dispatch(failure(error));
                    // dispatch(alertActions.error(error.toString()));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user, password: user.password, isPasswordExpired: user.isPasswordExpired, isRegisteredUser: user.isRegisteredUser } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function throwError(error) {
    return dispatch => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
    }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
    userService.logout();
    return { type: userConstants.LOGOUT };
}

function register(user) {
    return dispatch => {
        dispatch(request(user));

        userService.register(user)
            .then(
                user => {
                    dispatch(success());
                    goToLogin(history);
                    dispatch(alertActions.success('Registration successful'));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(user) { return { type: userConstants.REGISTER_REQUEST, user } }
    function success(user) { return { type: userConstants.REGISTER_SUCCESS, user } }
    function failure(error) { return { type: userConstants.REGISTER_FAILURE, error } }
}

